// Wer an Bord wo ist (B25, Erste Fassung, Runde 7): nach den Plätzen in public/art/boot/boote.json des Grafik-Leads.
// Käpt'n auf den Platz mit dem Posten kaeptn, Ausguck in den Korb, Heiler vor die erste Koje; wer in der Kajüte ruht,
// liegt der Reihe nach in den Kojen, dann sitzt der Gemeinschaftsraum auf den freien Plätzen (Hinweis „Crew verteilen“).
// So liegt der Patient des Heilers immer in der Koje, vor der er steht. Reine Darstellung.
import { postsOf, type RunState } from '../../sim/index.ts';
import type { Boot, Platz } from './data.ts';

export type Role = 'kaeptn' | 'ausguck' | 'gemeinschaft' | 'heiler' | 'kajuete';
/** Pose der Tiere an Bord (Manifest, kind crew) */
export type Pose = 'steuer' | 'steuerrad' | 'ausguck' | 'sitzen' | 'koje' | 'heilen';

/** Ein Tier an Bord auf seinem Platz */
export type Aboard = {
  key: string;
  species: string;
  look: number;
  role: Role;
  place: Platz;
  pose: Pose;
  /** Reihenfolge im Gemeinschaftsraum: Wer zusammen quatscht, wechselt sich ab */
  seat?: number;
};

const POSE_OF: Record<Exclude<Role, 'kaeptn'>, Pose> = { ausguck: 'ausguck', gemeinschaft: 'sitzen', heiler: 'heilen', kajuete: 'koje' };

/** Die Truppe an Bord nach ihren Posten auf den Plätzen des Boots */
export function aboardOf(run: RunState, boat: Boot): Aboard[] {
  const posts = postsOf(run);
  const out: Aboard[] = [];
  const taken = new Set<string>();
  const put = (id: string | null | undefined, role: Role, place: Platz | undefined, extra: Partial<Aboard> = {}) => {
    const f = id ? run.crew.find((c) => c.id === id && !c.away) : undefined;
    if (!f || !place) return false;
    const pose = role === 'kaeptn' ? ((Object.keys(place.posen)[0] as Pose | undefined) ?? 'steuer') : POSE_OF[role];
    if (!place.posen[pose]) return false;
    taken.add(place.id);
    out.push({ key: f.id, species: f.species, look: f.look ?? 0, role, place, pose, ...extra });
    return true;
  };
  const byPost = (post: string) => boat.plaetze.find((p) => p.posten.includes(post));
  put(posts.kaeptn, 'kaeptn', byPost('kaeptn'));
  put(posts.ausguck, 'ausguck', byPost('ausguck'));
  put(posts.heiler, 'heiler', byPost('heiler'));
  const free = (order: string[]) => order.map((id) => boat.plaetze.find((p) => p.id === id)).filter((p): p is Platz => !!p && !taken.has(p.id));
  for (const id of posts.kajuete) put(id, 'kajuete', free(boat.reihenfolge.koje)[0]);
  posts.gemeinschaft.forEach((id, i) => put(id, 'gemeinschaft', free(boat.reihenfolge.gemeinschaft)[0], { seat: i }));
  return out;
}
